import { colors } from '@akin-home/theme';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';

import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { openApp } from 'react-native-send-intent';
import styled from 'styled-components/native';
import { CAMERA_PACKAGE_NAME } from '../../app_library/data/built_in_apps';
import DashboardPanel from '../DashboardPanel';

interface Props {
  size?: number;
}

export const CameraWidget = ({ size }: Props) => {
  return (
    <Panel>
      <Container onPress={openCameraApp}>
        <FontAwesomeIcon
          icon={DUOTONE_CAMERA_ICON}
          color={colors.primary[70]}
          size={size || 75}
        />
      </Container>
    </Panel>
  );
};

const openCameraApp = () => openApp(CAMERA_PACKAGE_NAME, {});

const DUOTONE_CAMERA_ICON: IconProp = ['fad', 'camera'];

const Container = styled.TouchableOpacity`
  flex: 1;
  align-items: center;
  justify-content: center;
`;

const Panel = styled(DashboardPanel)`
  flex: 1;
`;
